import { TypeHolidayBundlesCardFields } from '@/core/generated-types';
import { ShopifyVariant } from '@/lib/shopify';

export const getBundleAvailability = (
  includes: TypeHolidayBundlesCardFields['includes'],
) => {
  return includes
    .filter((item) => item.sys.contentType.sys.id === 'product') // Filter only products
    .some((product) => {
      const variants = product.fields.shopifyProduct?.variants;
      if (variants && variants.length === 1) {
        // Single variant case
        return !variants[0].availableForSale;
      } else {
        // Multiple variants case
        return variants
          ? variants.every(
              (variant: ShopifyVariant) => !variant.availableForSale,
            )
          : null;
      }
    });
};
